export default "__VITE_ASSET__CFGObcwR__"